import { Injectable, inject } from '@angular/core';
import { EDeliverableType } from '@enums/campaign.enum';
import { IDeliverableConfig } from '../deliverable-list.interface';
import { TextDeliverableService } from '../shared/text-deliverable/text-deliverable.service';
import { CaptionComponent } from './caption.component';

@Injectable({
  providedIn: 'root',
})
export class CaptionService {
  private readonly textDeliverableService = inject(TextDeliverableService);

  public getConfig(): IDeliverableConfig {
    return this.textDeliverableService.getConfig({
      component: CaptionComponent,
      defaultNameTranslationKey: 'pages.campaignForm.ctaDialog.ctaDetails.deliverables.captionDeliverable.title',
      deliverableType: EDeliverableType.caption,
    });
  }
}
